import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/api/client";
import type { InvestigatorAssignment } from "@/api/types";

type Role = "pi" | "sub_investigator";

export function useAssignSiteDAInvestigator(siteId: string, daCode: string) {
  const qc = useQueryClient();
  return useMutation<
    InvestigatorAssignment,
    Error,
    { daId: string; investigatorId: string; role: Role; replace?: boolean; reason?: string }
  >({
    mutationFn: ({ daId, investigatorId, role, replace, reason }) =>
      apiRequest<InvestigatorAssignment>(
        `/api/sites/${siteId}/disease-areas/${daId}/investigators`,
        {
          method: "POST",
          body: JSON.stringify({
            investigator_id: investigatorId,
            role,
            replace: replace ?? false,
            ...(reason ? { reason } : {}),
          }),
        },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["sites", siteId, "clinops", daCode] });
    },
  });
}

export function useRemoveSiteDAInvestigator(siteId: string, daCode: string) {
  const qc = useQueryClient();
  return useMutation<
    void,
    Error,
    { daId: string; assignmentId: string; reason: string }
  >({
    mutationFn: ({ daId, assignmentId, reason }) =>
      apiRequest<void>(
        `/api/sites/${siteId}/disease-areas/${daId}/investigators/${assignmentId}`,
        { method: "DELETE", body: JSON.stringify({ reason }) },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["sites", siteId, "clinops", daCode] });
    },
  });
}
